export default __webpack_public_path__ + "static/media/phase1.a341fc6f.png";